export default {
  REWARDS: "Rewards",
  REWARD: "Reward",
  DAILYCHECKINREWARD: "Daily Check-In Reward",
};
